import * as React from "react";
import {UIState} from "data/UIState";
import {useEffect, useRef} from "react";
import {ExtTopper} from "../../login/ExtTopper";

export const WelcomeHeader = (props:{title?:string, description?:string}) => {

  const h1Ref = useRef(null);

  useEffect(()=>{
    if(h1Ref && h1Ref.current) {
      // @ts-ignore
      h1Ref.current.focus();
    }
  });

  // const openString = moment(UIState.settings.PLATFORM_OPEN_DATE).format("MMMM Do");

  return(
  <div className="signup-head">
    <ExtTopper />

    {props.title!=='' && <h1 className={'level1'} style={{marginTop:'20px'}} ref={h1Ref} >{!props.title ? <>Wellness Concepts Account Setup</> : <>{props.title}</>}</h1> }

    {props.description!=='' && (props.description ?  <p>{props.description}</p> :
        <p>Account setup takes just a few steps. Answer each question, and click the continue button
          to move on to the next step.&nbsp;
          {UIState.settings.PLATFORM_OPEN ?
            "Once you have completed setup, you will go to the dashboard, the starting point for participation in the Wellness Concepts Engagement Platform."
            :
            "The platform opens for participation on " + UIState.settings.PLATFORM_OPEN_DATE + ", but it is a good idea to register beforehand."
          }
        </p>
    )}

  </div>
  );
};
